import { RJSFSchema, UiSchema } from '@rjsf/utils';
import { getI18n } from 'react-i18next';

import { UI_SCHEMAS_LIBRARY } from '@/features/uiSchemasLibrary/constants/uiSchemasLibrary';
import { ITemplateFieldGroup } from '@/types/templates';
import { getUISchemaWithCustomOrder } from '@/utils/form/makeUISchemaOrder';

export function patchUiSchema(uiSchema: UiSchema, schema: RJSFSchema, schemaGroups: ITemplateFieldGroup[] | undefined) {
	const result = getUISchemaWithCustomOrder(uiSchema, schemaGroups);

	const patch = (schema: RJSFSchema) => {
		if (schema.properties) {
			const keys = Object.keys(schema.properties);

			keys.forEach((key) => {
				const property = schema.properties?.[key];

				if (typeof property === 'object' && 'uiSchemaKey' in property) {
					const uiSchemaKey = property.uiSchemaKey as string;
					const fieldSchema = UI_SCHEMAS_LIBRARY[uiSchemaKey] ?? {};

					result[key] = fieldSchema;
				}

                const i18n = getI18n();

                const directionOptions = {
                    direction: schema.definitions?.DirectionValues || {},
                    subDirection: schema.definitions?.SubDirectionValues || {},
                    subSubDirection: schema.definitions?.SubDirectionValues || {},
                }
                if (key in directionOptions) {
                    if (Object.keys(directionOptions[key]).length === 0) {
                        if (!(key in result)) {
                            result[key] = {};
                        }
                        result[key]['ui:disabled'] = true;
                        result[key]['ui:placeholder'] = i18n.t('application.noAvailableOptions');
                    }
                }
			});
		}

		if (schema.allOf) {
			schema.allOf.forEach((item) => typeof item === 'object' && patch(item));
		}
	};

	patch(schema);

	return result;
}
